module.exports = __webpack_public_path__ + "0660b3a563cddf15dfad9bf27aa0cdcb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/jeans-s.png
// module id = 1301
// module chunks = 0